/** @format */

import React from "react";
import { Pie } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Chart } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);
Chart.register(ChartDataLabels);

const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "right",
    },
    title: {
      display: false,
    },
    datalabels: {
      formatter: (value) => {
        return `${value}`;
      },
      color: "#fff",
      labels: {
        title: {
          font: {
            weight: "bold",
            size: 15,
          },
        },
      },
    },
  },
};

const PieChart = ({ d1, d2, d3, d4 }) => {
  const data = {
    labels: [
      `Samarqand - ${d1}`,
      `Navoiy - ${d4}`,
      `Qashqadaryo - ${d3}`,
      `Jizzax - ${d2}`,
    ],
    datasets: [ 
      {
        label: "Hududlar bo‘yicha taqsimot",
        data: [d1, d4, d3, d2],
        backgroundColor: [
          "#4F46E5",
          "#06B6D4",
          "#10B981",
          "#F59E0B",
          "#EF4444",
          "#8B5CF6",
        ],
        borderWidth: 0,
      },
    ],
  };

  return (
    <div className='pie-box' style={{ height: "500px" }}>
      <Pie data={data} options={options} />
    </div>
  );
};

export default PieChart;
